import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'next-i18next';

import styles from './Docs.module.scss';

interface Docs {
  translate: string;
}

interface TextArray {
  title: string;
  text: string[];
}

const Docs: React.FC<Docs> = ({ translate }) => {
  const { t } = useTranslation(translate);
  const textArray: [] = t(translate, { returnObjects: true });

  return (
    <main className={styles.docs}>
      <div className='container'>
        <h1 className={cn('title', 'title__main', styles.docs__title)}>
          {t('title')}
        </h1>
        {textArray.map((item: TextArray, i) => (
          <div key={i} className={styles.docs__item}>
            <h2 className={cn('title', styles.docs__titleSecond)}>
              {item.title}
            </h2>
            {item.text.map((text, t) => (
              <p key={i + t}>{text}</p>
            ))}
          </div>
        ))}
      </div>
    </main>
  );
};

export default Docs;
